import React from "react";
import { SHOW_RESERVED_STATUS_FILTER } from "../../utils/uiFlags";

const TABLE_STATUSES = [
  { key: "all", label: "All Tables", color: "#0f172a" },
  { key: "AVAILABLE", label: "Available", color: "#FFFFFF" },
  { key: "OCCUPIED", label: "Occupied", color: "#ADD8E6" },
  { key: "REQUEST_BILL", label: "Request Bill", color: "#FFFF00" },
  { key: "DRINK_REPEAT", label: "Drink Repeat", color: "#FFF1D6" },
  { key: "RESERVED", label: "Reserved", color: "#8B008B" },
  { key: "CLEANING", label: "Cleaning", color: "#A9A9A9" },
  { key: "IDLE", label: "Idle", color: "#FFF8CC" },
];

const StatusBar = ({
  stats,
  selectedFloor,
  onFloorChange,
  selectedStatus,
  onStatusChange,
  floors = [],
  isLoading = false,
}) => {
  // Build floors dropdown from API data
  const floorOptions = [
    { value: "All", label: "All Floors" },
    ...floors.map((floor) => ({
      value: floor.floorId || floor.id,
      label:
        floor.floorName || floor.name || `Floor ${floor.floorNumber || ""}`,
    })),
  ];
  const statusOptions = SHOW_RESERVED_STATUS_FILTER
    ? TABLE_STATUSES
    : TABLE_STATUSES.filter((status) => status.key !== "RESERVED");
  const selectedStatusValue =
    !SHOW_RESERVED_STATUS_FILTER && selectedStatus === "RESERVED"
      ? "all"
      : selectedStatus;

  return (
    <div className="pos-glass sticky top-0 z-40 px-4 py-2.5 transition-colors duration-200">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {/* Left: Floor Dropdown + Status Dropdown */}
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
          <div className="relative min-w-[180px] sm:min-w-[220px]">
            <select
              value={selectedFloor}
              onChange={(e) => onFloorChange(e.target.value)}
              disabled={isLoading}
              className="w-full appearance-none rounded-lg border border-slate-200 bg-white py-1.5 pl-3 pr-8 text-sm font-medium text-slate-900 transition-all duration-200 hover:border-indigo-300 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:border-indigo-600 dark:focus:ring-indigo-400"
            >
              {floorOptions.map((floor) => (
                <option key={floor.value} value={floor.value}>
                  {floor.label}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <svg
                className="h-3 w-3 text-slate-500 dark:text-slate-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div className="relative">
            <select
              value={selectedStatusValue}
              onChange={(e) => onStatusChange(e.target.value)}
              disabled={isLoading}
              className="appearance-none rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 pl-3 pr-8 py-1.5 text-sm font-medium text-slate-900 dark:text-slate-100 hover:border-indigo-300 dark:hover:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 focus:border-transparent transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {statusOptions.map((status) => (
                <option key={status.key} value={status.key}>
                  {status.label}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <svg
                className="h-3 w-3 text-slate-500 dark:text-slate-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="flex max-w-full items-center gap-2 overflow-x-auto">
          {TABLE_STATUSES.filter(
            (status) => status.key !== "all" && status.key !== "RESERVED",
          ).map((status) => (
            <div
              key={status.key}
              className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1 dark:border-slate-700 dark:bg-slate-800"
            >
              <div
                className="h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: status.color }}
              />
              <span className="text-xs font-medium text-slate-600 dark:text-slate-300">
                {status.label}
              </span>
              <span className="text-sm font-bold text-slate-900 dark:text-slate-100">
                {stats[status.key] || 0}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusBar;
